<script>
	let {
		class: className = '',
		children,
		header = null,
		footer = null,
	} = $props();
</script>

<article
	class={[
		'bg-indow-white text-indow-grey-dark relative flex flex-col overflow-hidden rounded-lg shadow-md',
		className,
	]}
>
	<header>{@render header?.()}</header>
	<div class="flex-grow px-5 py-3">
		{@render children()}
	</div>
	<div>{@render footer?.()}</div>
</article>
